import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import Stack from '@mui/material/Stack';

import { VpHookFormSwitch, VpConditionalUpgradeWrapper } from '../..';
import { useFetchPluginById } from '../../../hooks';
import { PLUGIN_STYLES_EDITING_ENABLED } from '../../../constants/feature-keys';

export const VpPluginSwitchSection = ({ name = '', label, children }) => {
  const { data } = useFetchPluginById();
  const defaultValue = data?.styles?.[name] || false;
  const { watch } = useFormContext();
  const isChecked = watch(name, defaultValue);

  return (
    <VpConditionalUpgradeWrapper featureKey={PLUGIN_STYLES_EDITING_ENABLED}>
      {({ isDisabled }) => {
        const childrenProps = {
          disabled: isDisabled
        };
        return (
          <Stack spacing="8px">
            <VpHookFormSwitch
              disabled={isDisabled}
              defaultValue={defaultValue}
              name={name}
              label={label}
            />
            {isChecked && cloneElement(children, { ...childrenProps })}
          </Stack>
        );
      }}
    </VpConditionalUpgradeWrapper>
  );
};

VpPluginSwitchSection.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired
};

export default VpPluginSwitchSection;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpPluginDetailsForm/VpPluginSwitchSection.jsx